
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import Hidden from '@material-ui/core/Hidden';

// entities
import { CampaignContact } from '../../entities/site';

const useStyles = makeStyles({
  table: {
    borderTop: "1px solid #CCCCCC"
  }
});

interface CampaignsTableProps {
  contacts: CampaignContact[];
  onClick(contact: CampaignContact): void;
}

const CampaignContactsTable: React.FC<CampaignsTableProps> = (props) => {

  const classes = useStyles();

  const rendertable = (item: CampaignContact, index: number) => {
    return (
      <TableRow key={`contact-row-${index}`}>
        <TableCell
          style={{ color: '#00ABC7', fontSize: 18, cursor: 'pointer' }}
          onClick={() => props.onClick(item)}
        >{item.firstName} {item.lastName}</TableCell>
        <Hidden only={['xs', 'sm']}>
          <TableCell >{item.address}</TableCell>
        </Hidden>
        <Hidden only={['xs', 'sm']}>
          <TableCell >{item.city}</TableCell>
        </Hidden>
        <Hidden only={['xs', 'sm']}>
          <TableCell >{item.state}</TableCell>
        </Hidden>
        <Hidden only={['xs', 'sm']}>
          <TableCell >{item.zip}</TableCell>
        </Hidden>
        <Hidden only={['xs', 'sm']}>
          <TableCell >{item.email}</TableCell>
        </Hidden>
        <TableCell >{item.phoneNumber}</TableCell>
      </TableRow>
    )
  }

  return (
    <div className="root">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <Hidden only={['xs', 'sm']}>
                <TableCell>Address</TableCell>
              </Hidden>
              <Hidden only={['xs', 'sm']}>
                <TableCell>City</TableCell>
              </Hidden>
              <Hidden only={['xs', 'sm']}>
                <TableCell>State</TableCell>
              </Hidden>
              <Hidden only={['xs', 'sm']}>
                <TableCell>Zip</TableCell>
              </Hidden>
              <Hidden only={['xs', 'sm']}>
                <TableCell>Email</TableCell>
              </Hidden>
              <TableCell>Phone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              props.contacts.map(rendertable)
            }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default CampaignContactsTable;




// WEBPACK FOOTER //
// ./src/components/campaign/CampaignContactsTable.tsx